import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import ActionProgressDialog from './ActionProgressDialog';

const ReportGenerateButton = ({
  onClick,
  loading,
  disabled,
  className,
  icon,
  label = 'Generate Report',
  loadingLabel = 'Preparing report...',
}) => {
  return (
    <>
    <Button
      type="button"
      variant="contained"
      onClick={onClick}
      disabled={disabled || loading}
      className={className}
      startIcon={!loading ? icon : undefined}
      sx={{
        textTransform: 'none',
      }}
    >
      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {icon ? <Box sx={{ display: 'flex', alignItems: 'center' }}>{icon}</Box> : null}
          <Typography component="span" sx={{ fontWeight: 700 }}>
            {loadingLabel}
          </Typography>
        </Box>
      ) : (
        label
      )}
    </Button>
    <ActionProgressDialog open={loading} message={loadingLabel || "Generating Report..."} />
    </>
  );
};

export default ReportGenerateButton;

